import commonServices from 'ApiService/Common/commonServices';
import branchService from 'ApiService/SuperAdmin/branchService';
import { notficationredirection } from 'components/navbar/notficationredirection';
import { AuthContext } from 'contexts/AuthContext';
import { formatDateText } from 'pages/helpers/dateUtils';
import BranchFilter from 'pages/SuperAdmin/Branch/BranchFilter';
import { useContext, useEffect, useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import ConfirmationModal from '../ConfirmationModal';
import { useRef } from 'react';

const Index = () => {
  const socketRef = useRef(null);

  const [notifications, setNotifications] = useState([]);
  const { state } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [processingIds, setProcessingIds] = useState([]);
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [branchFilterKey, setBranchFilterKey] = useState(0);
  const navigate = useNavigate();
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false);
  const [isUnpauseModalOpen, setIsUnpauseModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState({
    notificationId: '',
    studentId: '',
    isApproved: false,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedTopic, setSelectedTopic] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const notificationTypes = useMemo(() => {
    const types = [...new Set(notifications.map((note) => note.type))];
    return types;
  }, [notifications]);

  useEffect(() => {
    if (state?.user?.role === 'superadmin') {
      fetchJobs(state?.user?.role);
    }
  }, [state?.user?.role]);

  useEffect(() => {
    let filtered = notifications;

    if (selectedBranch) {
      filtered = filtered.filter((notification) => {
        const studentData = notification.studentData || notification.data;

        return (
          studentData?.branchId === selectedBranch ||
          studentData?.branch?._id === selectedBranch ||
          studentData?.branch === selectedBranch ||
          studentData?.name?._id === selectedBranch ||
          studentData?.branchName === selectedBranch
        );
      });
    }

    // Topic filter
    if (selectedTopic) {
      filtered = filtered.filter(
        (notification) => notification.type === selectedTopic
      );
    }

    // Deep search functionality
    if (searchQuery) {
      const searchTerm = searchQuery.toLowerCase().trim();

      filtered = filtered.filter((notification) => {
        const searchableText = [
          notification.message || '',
          notification.type || '',

          notification.studentData?.studentName || '',
          notification.studentData?.studentEmail || '',
          notification.studentData?.unpauseReason || '',
          notification.studentData?.studentId || '',
          notification.studentData?.phoneNumber || '',

          // Course/class data if available
          notification.studentData?.class?.courseName || '',
          notification.studentData?.class?.batchNumber || '',

          // Any additional fields that might contain relevant text
          notification.verificationStatus || '',
        ]
          .join(' ')
          .toLowerCase();

        // Check if the combined text includes the search term
        return searchableText.includes(searchTerm);
      });
    }

    setFilteredNotifications(filtered);
    setCurrentPage(1);
  }, [notifications, selectedBranch, selectedTopic, searchQuery]);

  useEffect(() => {
    if (!state?.user?.id) return;

    if (socketRef.current) return; // 🚫 already connected

    const socketURL = process.env.REACT_APP_API_BASE_URL.replace('/api/v1', '');

    socketRef.current = io(socketURL, {
      withCredentials: true,
      transports: ['websocket'], // 🔥 important
    });

    socketRef.current.on('connect', () => {
      console.log('✅ Socket connected:', socketRef.current.id);
      socketRef.current.emit('join', state.user.id);
    });

    socketRef.current.on('NotifyUser', (data) => {
      console.log('🔔 Realtime notification:', data);

      // Events are broadcast to everyone; skip ones addressed to another user
      if (
        typeof data.recipient === 'string' &&
        data.recipient !== state.user.id
      ) {
        return;
      }

      const newNotification = {
        _id: data.notificationId,
        type: data.type,
        message: data.message,
        studentData: data.studentData || data.data || null,
        isRead: false,
        createdAt: new Date().toISOString(),
        verificationStatus: data.verificationStatus || 'pending',
      };

      setNotifications((prev) => {
        if (prev.some((n) => n._id === newNotification._id)) return prev;
        return [newNotification, ...prev];
      });

      toast.success(data.message);
    });

    socketRef.current.on('disconnect', (reason) => {
      console.log('❌ Socket disconnected:', reason);
    });

    // ✅ CLEANUP ONLY ON UNMOUNT
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [state?.user?.id]);

  const fetchJobs = async (role) => {
    try {
      setLoading(true);
      const response = await commonServices.getJobNotifications(role);
      if (response.data.success) {
        setNotifications(
          response.data.notifications.map((notification) => ({
            ...notification,
            studentData: notification.data,
          }))
        );
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch job notifications.'
      );
    } finally {
      setLoading(false);
    }
  };

  // const handleNotificationClick = async (notification) => {
  //   try {
  //     if (!notification.isRead) {
  //       await commonServices.markNotificationAsRead(
  //         state?.user?.role,
  //         notification._id
  //       );

  //       setNotifications((prev) =>
  //         prev.map((item) =>
  //           item._id === notification._id ? { ...item, isRead: true } : item
  //         )
  //       );
  //     }

  //     const redirectPath = notficationredirection(
  //       notification.type,
  //       state?.user?.role
  //     );

  //     if (notification.data || notification.studentData) {
  //       const dataObj = notification.data || notification.studentData;

  //       if (typeof dataObj === 'string') {
  //         try {
  //           const parsedData = JSON.parse(dataObj);
  //           if (parsedData.id) {
  //             navigate(`${redirectPath}/${parsedData.id}`);
  //             return;
  //           } else if (parsedData.studentId) {
  //             navigate(`${redirectPath}/${parsedData.studentId}`);
  //             return;
  //           }
  //         } catch (error) {
  //           console.error('Failed to parse notification data:', error);
  //         }
  //       }
  //     }

  //     navigate(redirectPath);
  //   } catch (error) {
  //     console.error('Error handling notification click:', error);
  //     toast.error('Failed to process notification. Please try again.');
  //   }
  // };

  // Open verification confirmation modal

  const handleNotificationClick = async (notification) => {
    try {
      // 🚫 Do NOT auto-redirect for batch approvals
      if (
        notification.type === 'Batch Approval Request' ||
        notification.type === 'Batch Update Request'
      ) {
        // still mark as read
        if (!notification.isRead) {
          await commonServices.markNotificationAsRead(
            state?.user?.role,
            notification._id
          );

          setNotifications((prev) =>
            prev.map((item) =>
              item._id === notification._id ? { ...item, isRead: true } : item
            )
          );
        }
        return;
      }

      // ✅ Mark read for other notifications
      if (!notification.isRead) {
        await commonServices.markNotificationAsRead(
          state?.user?.role,
          notification._id
        );

        setNotifications((prev) =>
          prev.map((item) =>
            item._id === notification._id ? { ...item, isRead: true } : item
          )
        );
      }

      const redirectPath = notficationredirection(
        notification.type,
        state?.user?.role
      );

      // ✅ SAFE DATA PARSING
      const rawData = notification.studentData || notification.data;

      if (rawData) {
        if (typeof rawData === 'string') {
          try {
            const parsedData = JSON.parse(rawData);

            if (parsedData.id) {
              navigate(`${redirectPath}/${parsedData.id}`);
              return;
            }

            if (parsedData.studentId) {
              navigate(`${redirectPath}/${parsedData.studentId}`);
              return;
            }
          } catch (error) {
            console.error('Failed to parse notification data:', error);
          }
        }
      }

      navigate(redirectPath);
    } catch (error) {
      console.error('Error handling notification click:', error);
      toast.error('Failed to process notification. Please try again.');
    }
  };

  const openVerificationModal = (notificationId, studentId, isApproved) => {
    setModalAction({ notificationId, studentId, isApproved });
    setIsVerificationModalOpen(true);
  };

  // Open unpause placement confirmation modal
  const openUnpauseModal = (notificationId, studentId, isApproved) => {
    setModalAction({ notificationId, studentId, isApproved });
    setIsUnpauseModalOpen(true);
  };

  const handleVerification = async () => {
    const { notificationId, studentId, isApproved } = modalAction;

    try {
      setProcessingIds((prev) => [...prev, notificationId]);
      setIsVerificationModalOpen(false);

      const response = await branchService.verifyStudent(studentId, isApproved);

      if (response.data.success) {
        setNotifications((prev) =>
          prev.map((notification) =>
            notification._id === notificationId
              ? {
                  ...notification,
                  isRead: true,
                  verificationStatus: isApproved ? 'approved' : 'denied',
                }
              : notification
          )
        );

        toast.success(
          `Student ${isApproved ? 'approved' : 'denied'} successfully`
        );
      } else {
        toast.error('Failed to process student verification');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to process verification'
      );
    } finally {
      setProcessingIds((prev) => prev.filter((id) => id !== notificationId));
    }
  };

  const handleUnpausePlacement = async () => {
    const { notificationId, studentId, isApproved } = modalAction;

    try {
      setProcessingIds((prev) => [...prev, notificationId]);
      setIsUnpauseModalOpen(false);

      const response = await branchService.approveUnpausePlacement(
        notificationId,
        isApproved,
        isApproved ? 'Approved unpause request' : 'Denied unpause request'
      );

      if (response.data.success) {
        setNotifications((prev) =>
          prev.map((notification) =>
            notification._id === notificationId
              ? {
                  ...notification,
                  isRead: true,
                  verificationStatus: isApproved ? 'approved' : 'rejected',
                  actionBy: { name: state?.user?.name, role: 'Super Admin' },
                  actionAt: new Date().toISOString(),
                }
              : notification
          )
        );

        toast.success(
          `Placement ${isApproved ? 'resumed' : 'paused'} successfully`
        );
      } else {
        toast.error(
          response.data.message || 'Failed to process unpause request'
        );
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to process unpause request'
      );
    } finally {
      setProcessingIds((prev) => prev.filter((id) => id !== notificationId));
    }
  };

  const getStatusColor = (verificationStatus) => {
    switch (verificationStatus) {
      case 'approved':
        return 'bg-green-100 text-green-800';
      case 'denied':
      case 'rejected':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const resetFilters = () => {
    setSelectedBranch('');
    setSelectedTopic('');
    setSearchQuery('');
    setCurrentPage(1);

    setBranchFilterKey((prev) => prev + 1);
  };

  const renderStudentDetails = (studentData) => {
    if (!studentData) return null;

    return (
      <div className="mt-2 grid grid-cols-1 gap-4 text-sm text-gray-600 md:grid-cols-2">
        <div className="space-y-2">
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Name:</span>
            <span className="ml-2">{studentData.name}</span>
          </p>
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Email:</span>
            <span className="ml-2">{studentData.email}</span>
          </p>
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Contact:</span>
            <span className="ml-2">{studentData.contactNumber}</span>
          </p>
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Branch:</span>
            <span className="ml-2">{studentData.branchName}</span>
          </p>
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Student Course:</span>
            <span className="ml-2">
              {studentData.enrollments?.[0]?.courseName || 'N/A'}
            </span>
          </p>
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Branch:</span>
            <span className="ml-2">{studentData.branchName}</span>
          </p>
        </div>
        <div className="space-y-2">
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Education:</span>
            <span className="ml-2">
              {studentData.academicRecords?.[
                studentData.academicRecords.length - 1
              ]?.level || 'N/A'}
            </span>
          </p>
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Institution:</span>
            <span className="ml-2">
              {studentData.academicRecords?.[
                studentData.academicRecords.length - 1
              ]?.institutionName || 'N/A'}
            </span>
          </p>
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Fees:</span>
            <span className="ml-2">
              ₹{studentData.fees?.totalAmount?.toLocaleString() || '0'}
            </span>
          </p>
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Payment:</span>
            <span className="ml-2">
              {studentData.fees?.isFullPayment
                ? 'Full Payment'
                : 'Installments'}
            </span>
          </p>
          <p className="flex items-center">
            <span className="min-w-24 font-medium">Preferred Salary:</span>
            <span
              className={`ml-2 rounded-full px-2 py-0.5 text-xs font-semibold ${
                studentData.preferredSalary === 'More than 5 LPA'
                  ? 'bg-green-100 text-green-700'
                  : studentData.preferredSalary === 'Below 5 LPA'
                  ? 'bg-blue-100 text-blue-700'
                  : studentData.preferredSalary === 'Below 4 LPA'
                  ? 'bg-yellow-100 text-yellow-700'
                  : studentData.preferredSalary === 'Below 3 LPA'
                  ? 'bg-orange-100 text-orange-700'
                  : 'bg-gray-100 text-gray-700'
              }`}
            >
              {studentData.preferredSalary || 'Any Salary'}
            </span>
          </p>
        </div>
      </div>
    );
  };

  const handleApproveBatch = async (notification) => {
    try {
      setProcessingIds((prev) => [...prev, notification._id]);

      const data =
        typeof notification.data === 'string'
          ? JSON.parse(notification.data)
          : notification.data;

      const response = await commonServices.approveBatch({
        batchId: data.batchId,
        notificationId: notification._id,
      });

      if (response.data.success) {
        setNotifications((prev) =>
          prev.map((n) =>
            n._id === notification._id
              ? {
                  ...n,
                  isRead: true,
                  verificationStatus: 'approved',
                }
              : n
          )
        );

        toast.success('Batch approved successfully');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to approve batch');
    } finally {
      setProcessingIds((prev) => prev.filter((id) => id !== notification._id));
    }
  };

  const handleRejectBatch = async (notification) => {
    try {
      setProcessingIds((prev) => [...prev, notification._id]);

      const data =
        typeof notification.data === 'string'
          ? JSON.parse(notification.data)
          : notification.data;

      const response = await commonServices.rejectBatch({
        batchId: data.batchId,
        notificationId: notification._id,
      });

      if (response.data.success) {
        setNotifications((prev) =>
          prev.map((n) =>
            n._id === notification._id
              ? {
                  ...n,
                  isRead: true,
                  verificationStatus: 'denied',
                }
              : n
          )
        );

        toast.success('Batch rejected successfully');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to reject batch');
    } finally {
      setProcessingIds((prev) => prev.filter((id) => id !== notification._id));
    }
  };

  const handleApproveBatchUpdate = async (notification) => {
    try {
      setProcessingIds((prev) => [...prev, notification._id]);

      const rawData = notification.studentData || notification.data;

      if (!rawData) {
        toast.error('Invalid notification data');
        return;
      }

      const parsedData =
        typeof rawData === 'string' ? JSON.parse(rawData) : rawData;

      if (!parsedData.batchId) {
        toast.error('Batch ID missing');
        return;
      }

      const response = await commonServices.approveBatchUpdate({
        batchId: parsedData.batchId,
        notificationId: notification._id,
      });

      if (response.data.success) {
        setNotifications((prev) =>
          prev.map((n) =>
            n._id === notification._id
              ? { ...n, isRead: true, verificationStatus: 'approved' }
              : n
          )
        );

        toast.success('Batch update approved successfully');
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message || 'Failed to approve batch update'
      );
    } finally {
      setProcessingIds((prev) => prev.filter((id) => id !== notification._id));
    }
  };

  const handleRejectBatchUpdate = async (notification) => {
    try {
      setProcessingIds((prev) => [...prev, notification._id]);

      const rawData = notification.studentData || notification.data;

      if (!rawData) {
        toast.error('Invalid notification data');
        return;
      }

      const parsedData =
        typeof rawData === 'string' ? JSON.parse(rawData) : rawData;

      if (!parsedData.batchId) {
        toast.error('Batch ID missing');
        return;
      }

      const response = await commonServices.rejectBatchUpdate({
        batchId: parsedData.batchId,
        notificationId: notification._id,
      });

      if (response.data.success) {
        setNotifications((prev) =>
          prev.map((n) =>
            n._id === notification._id
              ? { ...n, isRead: true, verificationStatus: 'denied' }
              : n
          )
        );

        toast.success('Batch update rejected and reverted');
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message || 'Failed to reject batch update'
      );
    } finally {
      setProcessingIds((prev) => prev.filter((id) => id !== notification._id));
    }
  };

  const renderUnpausePlacementDetails = (studentData) => {
    if (!studentData) return null;

    return (
      <div className="mt-2 text-sm text-gray-600">
        <p className="flex items-center">
          <span className="min-w-24 font-medium">Student Name:</span>
          <span className="ml-2">{studentData.studentName}</span>
        </p>
        <p className="flex items-center">
          <span className="min-w-24 font-medium">Email:</span>
          <span className="ml-2">{studentData.studentEmail}</span>
        </p>
        <p className="flex items-center">
          <span className="min-w-24 font-medium">Unpause Reason:</span>
          <span className="ml-2">{studentData.unpauseReason || 'N/A'}</span>
        </p>
        {studentData.class && (
          <>
            <p className="flex items-center">
              <span className="min-w-24 font-medium">Course:</span>
              <span className="ml-2">
                {studentData.class.courseName || 'N/A'}
              </span>
            </p>
            <p className="flex items-center">
              <span className="min-w-24 font-medium">Batch Number:</span>
              <span className="ml-2">
                {studentData.class.batchNumber || 'N/A'}
              </span>
            </p>
          </>
        )}
      </div>
    );
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredNotifications.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredNotifications.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (loading) {
    return (
      <div className="flex h-40 items-center justify-center">
        <BallTriangle color="#5431ed" height={50} width={50} />
      </div>
    );
  }

  if (notifications.length === 0) {
    return (
      <div className="flex h-40 items-center justify-center">
        <div className="text-center text-gray-500">
          <p className="text-lg font-medium">No notifications found</p>
          <p className="mt-1 text-sm">New notifications will appear here</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-6">
      {/* Student Verification Confirmation Modal */}
      <ConfirmationModal
        isOpen={isVerificationModalOpen}
        onClose={() => setIsVerificationModalOpen(false)}
        onConfirm={handleVerification}
        title="Confirm Student Verification"
        message={`Are you sure you want to ${
          modalAction.isApproved ? 'accept' : 'reject'
        } this student registration?`}
        confirmText={
          processingIds.includes(modalAction.notificationId)
            ? 'Processing...'
            : modalAction.isApproved
            ? 'Accept'
            : 'Reject'
        }
        cancelText="Cancel"
        icon="info"
        disableConfirm={processingIds.includes(modalAction.notificationId)}
      />

      {/* Unpause Placement Confirmation Modal */}
      <ConfirmationModal
        isOpen={isUnpauseModalOpen}
        onClose={() => setIsUnpauseModalOpen(false)}
        onConfirm={handleUnpausePlacement}
        title="Confirm Placement Status Change"
        message={`Are you sure you want to ${
          modalAction.isApproved ? 'resume' : 'deny resuming'
        } this student's placement?`}
        confirmText={
          processingIds.includes(modalAction.notificationId)
            ? 'Processing...'
            : modalAction.isApproved
            ? 'Resume Placement'
            : 'Deny'
        }
        cancelText="Cancel"
        icon="info"
        disableConfirm={processingIds.includes(modalAction.notificationId)}
      />
      <div className="mb-6 flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white">
          Notifications
        </h1>

        <div className="flex flex-col space-y-4 md:flex-row md:items-center md:space-x-4 md:space-y-0">
          {/* Filter by Branch */}
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-600 dark:text-gray-300">
              Branch:
            </span>
            <div className="text-navy-800 dark:text-white">
              <BranchFilter
                key={branchFilterKey}
                onBranchChange={setSelectedBranch}
              />
            </div>
          </div>

          {/* Filter by Topic Type */}
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-600 dark:text-gray-300">
              Type:
            </span>
            <select
              value={selectedTopic}
              onChange={(e) => setSelectedTopic(e.target.value)}
              className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 dark:border-gray-600 dark:bg-navy-700 dark:text-white"
            >
              <option value="">All Types</option>
              {notificationTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          {/* Search by Student Name */}
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-600 dark:text-gray-300">
              Search:
            </span>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Student name..."
              className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 dark:border-gray-600 dark:bg-navy-700 dark:text-white"
            />
          </div>

          <button
            onClick={resetFilters}
            className="inline-flex items-center rounded-md bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 transition-colors duration-200 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600"
          >
            Reset Filters
          </button>
        </div>
      </div>

      <div className="space-y-4">
        {currentItems.length === 0 ? (
          <div className="flex h-40 items-center justify-center">
            <div className="text-center text-gray-500">
              <p className="text-lg font-medium">No notifications found</p>
              <p className="mt-1 text-sm">
                {selectedBranch || selectedTopic || searchQuery
                  ? 'No notifications match your current filters'
                  : 'New notifications will appear here'}
              </p>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            {currentItems.map((notification) => (
              <div
                key={notification._id}
                onClick={() => handleNotificationClick(notification)}
                className="overflow-hidden rounded-lg border border-gray-200 bg-white p-6 shadow-sm transition-all duration-200 hover:shadow-md dark:border-gray-700 dark:bg-navy-800"
              >
                <div className="flex flex-col space-y-4">
                  <div className="flex items-start justify-between">
                    <div>
                      <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
                        {notification.type}
                      </h2>
                      <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
                        {notification.message}
                      </p>
                    </div>
                    <span className="text-xs text-gray-500 dark:text-gray-400">
                      {formatDateText(notification.createdAt)}
                    </span>
                  </div>

                  {notification.type === 'Student Registration' &&
                    renderStudentDetails(notification.studentData)}

                  {notification.type === 'Unpause Placement Request' &&
                    renderUnpausePlacementDetails(notification.studentData)}

                  <div className="flex flex-col items-start justify-between space-y-4 pt-4 sm:flex-row sm:items-center sm:space-y-0">
                    {notification?.verificationStatus &&
                      notification.verificationStatus !== null && (
                        <span
                          className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${getStatusColor(
                            notification.verificationStatus
                          )}`}
                        >
                          {notification.verificationStatus
                            ? notification.verificationStatus
                                .charAt(0)
                                .toUpperCase() +
                              notification.verificationStatus.slice(1)
                            : 'Pending'}
                        </span>
                      )}

                    {notification.actionBy?.name && (
                      <span className="text-xs text-gray-600 dark:text-gray-300">
                        {notification.verificationStatus === 'approved'
                          ? 'Approved'
                          : 'Rejected'}{' '}
                        by{' '}
                        <span className="font-semibold">
                          {notification.actionBy.name}
                        </span>{' '}
                        ({notification.actionBy.role})
                        {notification.actionAt &&
                          ` · ${new Date(notification.actionAt).toLocaleString()}`}
                      </span>
                    )}

                    {/* Student Registration Verification Buttons */}
                    {/* {notification.type === 'Student Registration' &&
                      (!notification.verificationStatus ||
                        notification.verificationStatus === 'pending') &&
                      notification.studentData && (
                        <div className="flex gap-3">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleVerification(
                                notification._id,
                                notification.studentData.studentId,
                                true
                              );
                            }}
                            disabled={processingIds.includes(notification._id)}
                            className="inline-flex items-center rounded-md bg-green-500 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                          >
                            {processingIds.includes(notification._id) ? (
                              <>Processing...</>
                            ) : (
                              'Accept'
                            )}
                          </button>
                        </div>
                      )} */}
                    {/* Student Registration Verification Buttons */}
                    {notification.type === 'Student Registration' &&
                      (!notification.verificationStatus ||
                        notification.verificationStatus === 'pending') &&
                      notification.studentData && (
                        <div className="flex gap-3">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              openVerificationModal(
                                notification._id,
                                notification.studentData.studentId,
                                true
                              );
                            }}
                            disabled={processingIds.includes(notification._id)}
                            className="inline-flex items-center rounded-md bg-green-500 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                          >
                            {processingIds.includes(notification._id) ? (
                              <>Processing...</>
                            ) : (
                              'Accept'
                            )}
                          </button>
                          {/* <button
                            onClick={(e) => {
                              e.stopPropagation();
                              openVerificationModal(
                                notification._id,
                                notification.studentData.studentId,
                                false
                              );
                            }}
                            disabled={processingIds.includes(notification._id)}
                            className="inline-flex items-center rounded-md bg-red-500 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                          >
                            {processingIds.includes(notification._id) ? (
                              <>Processing...</>
                            ) : (
                              'Reject'
                            )}
                          </button> */}
                        </div>
                      )}

                    {/* Unpause Placement Request Buttons */}
                    {notification.type === 'Unpause Placement Request' &&
                      (!notification.verificationStatus ||
                        notification.verificationStatus === 'pending') &&
                      notification.studentData && (
                        <div className="flex gap-3">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              openUnpauseModal(
                                notification._id,
                                notification.studentData.studentId,
                                true
                              );
                            }}
                            disabled={processingIds.includes(notification._id)}
                            className="inline-flex items-center rounded-md bg-green-500 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                          >
                            {processingIds.includes(notification._id) ? (
                              <>Processing...</>
                            ) : (
                              'Resume Placement'
                            )}
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              openUnpauseModal(
                                notification._id,
                                notification.studentData.studentId,
                                false
                              );
                            }}
                            disabled={processingIds.includes(notification._id)}
                            className="inline-flex items-center rounded-md bg-red-500 px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                          >
                            {processingIds.includes(notification._id) ? (
                              <>Processing...</>
                            ) : (
                              'Deny'
                            )}
                          </button>
                        </div>
                      )}

                    {notification.type === 'Batch Approval Request' &&
                      (!notification.verificationStatus ||
                        notification.verificationStatus === 'pending') && (
                        <div className="flex gap-3">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleApproveBatch(notification);
                            }}
                            disabled={processingIds.includes(notification._id)}
                            className="inline-flex items-center rounded-md bg-green-500 px-4 py-2 text-sm font-medium text-white hover:bg-green-600 disabled:opacity-50"
                          >
                            {processingIds.includes(notification._id)
                              ? 'Processing...'
                              : 'Approve'}
                          </button>

                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRejectBatch(notification);
                            }}
                            disabled={processingIds.includes(notification._id)}
                            className="inline-flex items-center rounded-md bg-red-500 px-4 py-2 text-sm font-medium text-white hover:bg-red-600 disabled:opacity-50"
                          >
                            {processingIds.includes(notification._id)
                              ? 'Processing...'
                              : 'Reject'}
                          </button>
                        </div>
                      )}

                    {notification.type === 'Batch Update Request' &&
                      (!notification.verificationStatus ||
                        notification.verificationStatus === 'pending') && (
                        <div className="flex gap-3">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleApproveBatchUpdate(notification);
                            }}
                            disabled={processingIds.includes(notification._id)}
                            className="inline-flex items-center rounded-md bg-green-500 px-4 py-2 text-sm font-medium text-white hover:bg-green-600 disabled:opacity-50"
                          >
                            {processingIds.includes(notification._id)
                              ? 'Processing...'
                              : 'Approve Update'}
                          </button>

                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRejectBatchUpdate(notification);
                            }}
                            disabled={processingIds.includes(notification._id)}
                            className="inline-flex items-center rounded-md bg-red-500 px-4 py-2 text-sm font-medium text-white hover:bg-red-600 disabled:opacity-50"
                          >
                            {processingIds.includes(notification._id)
                              ? 'Processing...'
                              : 'Reject Update'}
                          </button>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Pagination Controls */}
        {filteredNotifications.length > 0 && (
          <div className="mt-6 flex items-center justify-between border-t border-gray-200 px-4 py-3 dark:border-gray-700">
            <div className="flex items-center">
              <select
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="rounded-md border border-gray-300 px-2 py-1 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 dark:border-gray-600 dark:bg-navy-700 dark:text-white"
              >
                {/* <option value={5}>5 per page</option> */}
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
              </select>
              <span className="ml-3 text-sm text-gray-500 dark:text-gray-400">
                Showing {indexOfFirstItem + 1} to{' '}
                {Math.min(indexOfLastItem, filteredNotifications.length)} of{' '}
                {filteredNotifications.length} results
              </span>
            </div>

            <div className="flex space-x-1">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-1 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:bg-navy-700 dark:text-white dark:hover:bg-navy-600"
              >
                Previous
              </button>

              {Array.from({ length: Math.min(totalPages, 5) }).map((_, idx) => {
                let pageNum;

                if (totalPages <= 5) {
                  pageNum = idx + 1;
                } else if (currentPage <= 3) {
                  pageNum = idx + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNum = totalPages - 4 + idx;
                } else {
                  pageNum = currentPage - 2 + idx;
                }

                return (
                  <button
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    className={`inline-flex items-center rounded-md border px-3 py-1 text-sm font-medium shadow-sm ${
                      currentPage === pageNum
                        ? 'border-indigo-500 bg-indigo-50 text-indigo-600 dark:bg-indigo-900 dark:text-indigo-300'
                        : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-navy-700 dark:text-white dark:hover:bg-navy-600'
                    }`}
                  >
                    {pageNum}
                  </button>
                );
              })}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage >= totalPages}
                className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-1 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:bg-navy-700 dark:text-white dark:hover:bg-navy-600"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Index;
